import * as FPT from '../utility/fpt';
/**
 * This function will add the class provided to the element or elements
 * @param {string} selector - elements selector
 * @param {string[]} classNames - array of class name(s) to add
 */
export function addClass(selector, classNames) {
  const elementsSelected = document.querySelectorAll(selector);
  for (let i = 0; i < elementsSelected.length; i++) {
    elementsSelected[i].classList.add(...classNames);
  }
}

/**
* This function will remove the class provided from the element or elements
* @param {string} selector - elements selector
* @param {string[]} classNames - array of class name(s) to remove
*/
export function removeClass(selector, classNames) {
  const elementsSelected = document.querySelectorAll(selector);
  for (let i = 0; i < elementsSelected.length; i++) {
    elementsSelected[i].classList.remove(...classNames);
  }
}

/**
* This function shows the hidden element
* @param {string} selector - element selector
* @param {string} [display] - display property value
*/
export function show(selector, display = 'block') {
  const elementsToShow = document.querySelectorAll(selector);
  for (let i = 0; i < elementsToShow.length; i++) {
    elementsToShow[i].style.display = display;
  }
}

/**
* This function hides the selected element
* @param {string} selector - element selector
*/
export function hide(selector) {
  const elementsToHide = document.querySelectorAll(selector);
  for (let i = 0; i < elementsToHide.length; i++) {
    elementsToHide[i].style.display = 'none';
  }
}

/**
* This function binds the fpti click event for 
* all the elements having data-fpti aatribute
*/
export function bindFPTIClicks(data={}) {
  let fptiElements = document.querySelectorAll('[data-fpti]');
  for (let fptiElement of fptiElements) {
    fptiElement.addEventListener('click', function () {
      FPT.trackButtonClick(this.getAttribute('data-fpti'), { event_name: `${this.getAttribute('data-fpti')}_clicked`, product: data.product });
    })
  }
}

export function triggerHelpCenter() {
  const html = document.querySelector('html');
  const countryCode = html.getAttribute('country') || 'US';
  const helpCenterSpark = window && window.helpCenterSpark;
  if (helpCenterSpark && ['CA', 'GB', 'AU'].lastIndexOf(countryCode) >= 0) {
    helpCenterSpark('showTopic', { topicId: 'NONPROFITS_AND_DONATIONS' });
  } else if (helpCenterSpark && ['US', 'IE'].lastIndexOf(countryCode) >= 0) {
    helpCenterSpark('showArticleList',
      {
        productId: 'PAYPAL_GIVING_FUND',
        pageId: 'PPGF_Dashboard_help_FAQ',
        fieldId: 'DASHBOARD_HELP_LINK',
        streamlined: true
      });
  }
}

export function validateEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}
